"use client";
import { jsx as e, Fragment as l } from "react/jsx-runtime";
import { createSvgIcon as t } from "@mui/material/utils";
const n = t(
  /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M6.50004 1.79004H17.5C20.1 1.79004 22.21 3.90004 22.21 6.50004V17.5C22.21 20.1 20.1 22.21 17.5 22.21H6.50004C3.90004 22.21 1.79004 20.1 1.79004 17.5V6.50004C1.79004 3.90004 3.90004 1.79004 6.50004 1.79004ZM16 12.71H8.00004C7.61004 12.71 7.29004 12.39 7.29004 12C7.29004 11.61 7.61004 11.29 8.00004 11.29H16C16.39 11.29 16.71 11.61 16.71 12C16.71 12.39 16.39 12.71 16 12.71Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }),
  "KmxCheckboxIndeterminateFilled"
);
export {
  n as default
};
